// link added should be exactly as you see it after bluemail.me
// Functionality work only on exactly pathname to not hide by mistake something else
const HidenPages = [
];

export default HidenPages